// TSS vite/03 §"Query keys convention".

export const opuKeys = {
    all:    ['opu'],
    list:   (filters)    => ['opu', 'list', filters],
    detail: (id, view)   => ['opu', 'detail', id, view ?? 'standard'],
    transferSessions: (id) => ['opu', 'transfer-sessions', id],
};
